import { render, staticRenderFns } from "./editor-audio.vue?vue&type=template&id=6592a3bb&scoped=true&"
import script from "./editor-audio.vue?vue&type=script&lang=ts&"
export * from "./editor-audio.vue?vue&type=script&lang=ts&"
import style0 from "./editor-audio.vue?vue&type=style&index=0&id=6592a3bb&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6592a3bb",
  null
  
)

export default component.exports